// extracted by mini-css-extract-plugin
export default {"servicesWrapper":"_Services_servicesWrapper__nKr0X"};